const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;

let initialized = false;

function initGA() {
  if (initialized || !GA_ID) return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  // Served first-party by the backend's /vendor/gtag.js proxy so we don't
  // pull in an external script without an SRI attribute (TAC low-severity
  // finding). Collection requests from gtag.js still go direct to
  // google-analytics.com at runtime.
  script.src = `/vendor/gtag.js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
}

export function trackEvent(name: string, params?: Record<string, string>) {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", name, params);
}

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

initGA();
